import React from 'react';
import { LinkCell } from '@hud/web-components/Table/Table';
import { CellContext } from '@tanstack/react-table';
import { FlowByFunction } from '@hud/portal-dtos/webapp-function.dto';
import { BreadcrumbItem } from '@hud/web-components/Breadcrumbs/Breadcrumbs';
import { getDisplayMethod, getIconForFlow } from '@hud/web-components/utils';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { CellIcon, EntityWithIconContainer } from './FlowCellRenderer.styles';

export default function renderFlowEntryPoint<TData extends FlowByFunction>(
  referralBreadcrumbs?: BreadcrumbItem[],
  multiGroupTopics: string[] = [],
  filters?: string | undefined,
) {
  return function CellRenderer(cell: CellContext<TData, number>) {
    const row = cell.row.original;

    const isMultiGroupTopic = (topic_name: string) => multiGroupTopics.includes(topic_name);

    const getRowDisplayAndUrl = (row: typeof cell.row.original) => {
      let displayElement = '';
      let url = '';

      switch (row.type) {
        case 'ENDPOINT':
          displayElement = `${getDisplayMethod(row.methods)} ${row.path}`;
          url = `/explore/endpoints/${row.id}-${row.service.id}?${filters}`;
          break;

        case 'KAFKA':
          displayElement = `${row.kafka_topic_name}${isMultiGroupTopic(row.kafka_topic_name) ? ` (group ${row.kafka_topic_group_id})` : ''}`;
          url = `/explore/messageQueues/${row.id}?${[filters, `service=${row.service.id}`].join('&')}`;
          break;

        case 'SQS':
          displayElement = row.sqs_queue_name;
          url = `/explore/messageQueues/${row.id}?${[filters, `service=${row.service.id}`].join('&')}`;
          break;

        default:
          displayElement = '';
          url = '';
      }

      return { displayElement, url };
    };

    const { displayElement, url } = getRowDisplayAndUrl(row);

    return (
      <LongContentPopover>
        <EntityWithIconContainer>
          <CellIcon icon={getIconForFlow(row.type)} size="20px" />
          <LinkCell
            to={url}
            state={{ referralBreadcrumbs: referralBreadcrumbs }}
          >
            {displayElement}
          </LinkCell>
        </EntityWithIconContainer>
      </LongContentPopover>
    );
  };
}
